import axios from "axios";

export function getBaskets() {
    return axios.get('order/baskets');
}

export function newProduct(data) {
    return axios.post('admin/orders', data);
}

export function getProduct(id) {
    return axios.get(`admin/products/${id}`);
}

export function updateProduct(id, data) {
    return axios.put(`admin/products/${id}`, data );
}

export function deleteProduct(id) {
    return axios.delete(`admin/products/${id}`);
}